
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';
import EventSummary from '../EventSummary';

class HomePageSlider extends React.Component {

    _getRandomModuleBackgroundStyle() {

        const randomId = Math.floor(Math.random() * this.props.modules.length-1) + 0;
        const modules = this.props.modules.filter(module => module.background_image !== null);
        const moduleId = modules[randomId] ? modules[randomId].id : null;

        if(moduleId) {
            return {
                backgroundImage: `url('/api/v1/modules/${moduleId}/image')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat'
            };
        }


    }

    render() {

        return (
            <article className={style['top-section']}>

                <div className={style['slide7']}></div>
                <div className={style['slide6']}></div>
                <div className={style['slide5']}></div>
                <div className={style['slide4']}></div>
                <div className={style['slide3']}></div>
                <div className={style['slide2']}></div>
                <div className={style['slide1']}></div>

                <div className={style['section-content']}>

                    <h1 className={style['training-header']}>training</h1>

                    <div className={style['top-section__box-container']}>

                        <div className={style['top-section__logo-box']}> </div>

                        <div className={style['top-section__description-box']}>
                            <p className={style['top-section__description']}>
                                RHE delivers considered,
                                effective training courses
                                for those at the sharp
                                end. Public, private and
                                third sector staff – our
                                aim is to connect those
                                with a need to a person
                                who can help.
                            </p>
                        </div>

                        <div className={style['top-section__module-box']} style={this._getRandomModuleBackgroundStyle()}></div>

                        <div className={style['featured-testimonial']}>

                            <span className={style['featured-testimonial__quote-icon']}>“</span>

                            <span className={style['featured-testimonial__content']}>
                                Good content, relevant, with a good mix of theory and practice.
                            </span>

                            <span className={style['featured-testimonial__author']}>
                                Environmental Health Officer, Aylesbury Vale District Council
                            </span>


                        </div>
                    </div>

                </div>

            </article>
        );
    }
}

export default CSSModules(HomePageSlider, style);


// WEBPACK FOOTER //
// ./components/HomePageSlider/index.js